/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'

// Create Virtual Routes

const ChartMintLazyImport = createFileRoute('/chart/$mint')()

// Create/Update Routes

const ChartMintLazyRoute = ChartMintLazyImport.update({
  id: '/chart/$mint',
  path: '/chart/$mint',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/chart/$mint.lazy').then((d) => d.Route))

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/chart/$mint': {
      id: '/chart/$mint'
      path: '/chart/$mint'
      fullPath: '/chart/$mint'
      preLoaderRoute: typeof ChartMintLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/chart/$mint': typeof ChartMintLazyRoute
}

export interface FileRoutesByTo {
  '/chart/$mint': typeof ChartMintLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/chart/$mint': typeof ChartMintLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/chart/$mint'
  fileRoutesByTo: FileRoutesByTo
  to: '/chart/$mint'
  id: '__root__' | '/chart/$mint'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  ChartMintLazyRoute: typeof ChartMintLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  ChartMintLazyRoute: ChartMintLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/chart/$mint"
      ]
    },
    "/chart/$mint": {
      "filePath": "chart/$mint.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
